import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

import { useImpactReportContactUs } from "../../hooks/useImpactReportContactUs";
import { industryTransitionKeys } from "../../utils/i18n";

export const ImpactReportContactUs = () => {
    const { translate } = useTranslate();
    const { showContactUs, handleContactUs } = useImpactReportContactUs();

    if (!showContactUs) {
        return null;
    }

    return (
        <Button
            buttonHtmlType="button"
            type="flat"
            onClick={handleContactUs}
            data-automation="industry-transition-impact-report-contact-us"
        >
            {translate(industryTransitionKeys.reportContactUs)}
        </Button>
    );
};
